export function renderBullet(swiper, index, className) {
  function updateButton() {
    let slide = [...swiper.slides].find(slide => slide.dataset.swiperSlideIndex === String(index))

    let bullet = swiper.pagination.bullets[index]
    bullet.setAttribute('aria-disabled', String(index === swiper.realIndex))
    bullet.setAttribute('aria-label', slide.getAttribute('aria-label'))
  }

  swiper.on('slideChange', updateButton)
  swiper.on('afterInit', updateButton)

  return `<button class="${className}"></button>`
}

export function hideClonedSlidesFromScreenReaders(swiper) {
  function updateSlideAccessibility(slide) {
    if (slide.classList.contains('swiper-slide-duplicate')) {
      slide.setAttribute('aria-hidden', 'true')
      slide.setAttribute('tabindex', '-1')
    } else {
      slide.removeAttribute('aria-hidden')
      slide.removeAttribute('tabindex')
    }
  }

  let slideObservers = new WeakMap()
  function observeSlide(slide) {
    let slideObserver = new MutationObserver(mutations => {
      for (let mutation of mutations) {
        if (mutation.attributeName === 'class') {
          updateSlideAccessibility(mutation.target)
        }
      }
    })
    slideObserver.observe(slide, {
      attributes: true,
      attributeFilter: ['class'],
    })
    slideObservers.set(slide, slideObserver)

    updateSlideAccessibility(slide)
  }

  // Observe slides wrapper, so we can observe each new slide
  let wrapperObserver = new MutationObserver(mutations => {
    for (let mutation of mutations) {
      for (let slide of mutation.addedNodes) {
        if (slide.classList.contains('swiper-slide')) {
          observeSlide(slide)
        }
      }

      for (let slide of mutation.removedNodes) {
        if (slideObservers.has(slide)) {
          slideObservers.get(slide).disconnect()
          slideObservers.delete(slide)
        }
      }
    }
  })
  wrapperObserver.observe(swiper.wrapperEl, { childList: true })
  ;[...swiper.slides].forEach(observeSlide)
}
